import React from 'react';
import { X } from 'lucide-react';
import './Impressum.css';

const Impressum = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="impressum-overlay" onClick={onClose}>
      <div className="impressum-modal" onClick={(e) => e.stopPropagation()}>
        <button className="impressum-close" onClick={onClose} aria-label="Schließen">
          <X size={24} />
        </button>
        
        <h1 className="impressum-title">Impressum</h1>
        
        <div className="impressum-content">
          <section className="impressum-section">
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              Frost Studio OHG<br />
              Gottfried-Keller-Straße 69<br />
              01157 Dresden
            </p>
          </section>

          <section className="impressum-section">
            <h2>Kontakt</h2>
            <p>
              Telefon: 0162 2112584<br />
              E-Mail: kontakt@froststudio.de
            </p>
          </section>

          <section className="impressum-section">
            <h2>Registereintrag</h2>
            <p>
              Sitz in Dresden [HRA 12340]<br />
              Amtsgericht Dresden
            </p>
          </section>

          <section className="impressum-section">
            <h2>Geschäftsführer</h2>
            <p>
              Maximilian Slota<br />
              Tzvetomir Lasarov
            </p>
          </section>

          <section className="impressum-section">
            <h2>Umsatzsteuer-ID</h2>
            <p>
              Steuernummer: 203/153/00569<br />
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE457027814
            </p>
          </section>

          <section className="impressum-section">
            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Maximilian Slota & Tzvetomir Lasarov<br />
              Gottfried-Keller-Straße 69<br />
              01157 Dresden
            </p>
          </section>

          <section className="impressum-section">
            <h2>Haftungsausschluss</h2>
            <h3>Haftung für Inhalte</h3>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>
            
            <h3>Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            </p>
          </section>

          <section className="impressum-section">
            <h2>Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;